import { commitMutation, Environment } from "react-relay";
import { relayAuthEnvironment } from "@/RelayEnvironment";
import { graphql } from "relay-runtime";
import {
    MoveBookingInput,
    MoveBookingMutationResponse,
} from "@/Domains/DispositionManagement/Mutations/__generated__/MoveBookingMutation.graphql";
import { BaseError } from "@/Utils/BaseError";

export default (
    input: MoveBookingInput,
    onCompleted: (error: Error | null, result?: string | null) => void,
) => {
    // @ts-ignore
    commitMutation(relayAuthEnvironment() as Environment, {
        mutation: graphql`
            mutation MoveBookingMutation($input: MoveBookingInput!) {
                moveBooking(input: $input) {
                    bookingId
                    vehicle {
                        vehicleId
                    }
                }
            }
        `,
        variables: {
            input: input,
        },
        onCompleted(result) {
            const res = result as MoveBookingMutationResponse;
            const bookingId: string | null | undefined =
                res.moveBooking?.bookingId;

            if (bookingId) {
                onCompleted(null, bookingId);
                return;
            }

            throw new BaseError(
                "DispoRejectBookingMutation failed with an unexpected Error",
                {
                    context: {
                        bookingId: input.bookingId,
                        sourceVehicleId: input.sourceVehicleId,
                        destinationVehicleId: input.destinationVehicleId,
                    },
                },
            );
        },
        onError(err) {
            onCompleted(err);
        },
    });
};
